import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface BlockedHashtag {
	id: string;
	word: string;
	created_at: string;
}

const fetchBlockedHashtags = async (): Promise<BlockedHashtag[]> => {
	const response = await cmsClient.get<BlockedHashtag[]>(
		"/homepage/admin/hashtags/blocked/"
	);

	return response.data;
};

const useBlockedHashtags = () => {
	return useQuery(["blocked-hashtags"], fetchBlockedHashtags);
};

export type { BlockedHashtag };
export default useBlockedHashtags;
